module.exports = __webpack_public_path__ + "static/media/merlin_183135423_1167fa8a-7940-427e-b690-68876010d286-superJumbo.5054a14d.jpg";